import { render, staticRenderFns } from "./userNotificationList.vue?vue&type=template&id=0f10050d&scoped=true&"
import script from "./userNotificationList.vue?vue&type=script&lang=js&"
export * from "./userNotificationList.vue?vue&type=script&lang=js&"
import style0 from "./userNotificationList.vue?vue&type=style&index=0&id=0f10050d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f10050d",
  null
  
)

export default component.exports